import { render, staticRenderFns } from "./slideBannerTab.vue?vue&type=template&id=cb691932&scoped=true&lang=pug"
import script from "./slideBannerTab.vue?vue&type=script&lang=js"
export * from "./slideBannerTab.vue?vue&type=script&lang=js"
import style0 from "./slideBannerTab.vue?vue&type=style&index=0&id=cb691932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb691932",
  null
  
)

export default component.exports